import { useCallback } from 'react'
import Decimal from 'decimal.js-light'

export default function useConsumptionTax() {
  return {
    calc8percent: useCallback((price: number) => Math.trunc(new Decimal(price).times(0.08).toNumber()), []),
    calc10percent: useCallback((price: number) => Math.trunc(new Decimal(price).times(0.1).toNumber()), []),
  }
}
